import { render, staticRenderFns } from "./uploadPhoto.vue?vue&type=template&id=cc131a06"
import script from "./uploadPhoto.vue?vue&type=script&lang=js"
export * from "./uploadPhoto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports